import { Typography } from "@mui/material";
import { IMessageContentTypeBubble } from "../../MessagePanel";
import {
  LocationClickable,
  LocationContainer,
  MapImage,
  PlaceName,
} from "./LocationContent.style";
import ExpandableText from "../../../common/ExpandableText";

const LocationContent = ({ message }: IMessageContentTypeBubble) => {
  const messageData = message.getMessage();
  const { location } = messageData;

  if (!location) {
    return (
      <Typography variant="body1" data-testid="message-content-location">
        <ExpandableText>
          {messageData.body ?? messageData.fallbackMessage}
        </ExpandableText>
      </Typography>
    );
  }

  const handleOpenMap = () => {
    const { lat, lng } = location;
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`,
      "_blank",
    );
  };

  return (
    <LocationContainer data-testid="message-content-location">
      {location.mapUrl && (
        <LocationClickable onClick={handleOpenMap}>
          <MapImage
            src={location.mapUrl}
            alt={location.placeName || "Location"}
          />
        </LocationClickable>
      )}
      {location.placeName && (
        <PlaceName>
          <Typography variant="body2">{location.placeName}</Typography>
        </PlaceName>
      )}
    </LocationContainer>
  );
};

export default LocationContent;
